import React from "react";
import { Route, Routes } from "react-router-dom";
import RouteNames from "./RouteName";
import Skeleton from "./Skeleton";
import Profile from "../components/Profile";

import Login from "../pages/login/Login";

import HomeDashboard from "../pages/HomeDashboard";

import UserAddForm from "../pages/user/add";
import UserList from "../pages/user/list";
import UserEdit from "../pages/user/edit";

import FleetMasterAddForm from "../pages/corporate-admin/fleetmaster/add";
import FleetMasterView from "../pages/corporate-admin/fleetmaster/edit";
import FleetMasterList from "../pages/corporate-admin/fleetmaster/list";

import DriverMasterAddForm from "../pages/corporate-admin/drivermaster/add";
import DriverMasterList from "../pages/corporate-admin/drivermaster/list";
import DriverMasterEdit from "../pages/corporate-admin/drivermaster/edit";

import HelperMasterAddForm from "../pages/corporate-admin/helpermaster/add";
import HelperMasterView from "../pages/corporate-admin/helpermaster/list";
import HelperMasterEdit from "../pages/corporate-admin/helpermaster/edit";

import CustomerMasterAddForm from "../pages/corporate-admin/customermaster/add";
import CustomerMasterView from "../pages/corporate-admin/customermaster/list";
import CustomerMasterEditForm from "../pages/corporate-admin/customermaster/edit";

import VendorMasterAdd from "../pages/corporate-admin/vendormaster/add";
import VendorMasterView from "../pages/corporate-admin/vendormaster/list";
import VendorMasterEdit from "../pages/corporate-admin/vendormaster/edit";

import LaneMasterAdd from "../pages/corporate-admin/lanemaster/add";
import LaneMasterView from "../pages/corporate-admin/lanemaster/list";
import LaneMasterEdit from "../pages/corporate-admin/lanemaster/edit";

import ContractorMasterAdd from "../pages/corporate-admin/contractormaster/add";
import ContractorMasterView from "../pages/corporate-admin/contractormaster/list";
import ContractorMasterEdit from "../pages/corporate-admin/contractormaster/edit";

import LocationMasterAdd from "../pages/corporate-admin/locationmaster/add";
import LocationMasterView from "../pages/corporate-admin/locationmaster/list";
import LocationMasterEdit from "../pages/corporate-admin/locationmaster/edit";

import ContractualTripAdd from "../pages/trip/add";
import ContractualTripEdit from "../pages/trip/edit";
import ContractualTripView from "../pages/trip/list";

import AdhocLaneAdd from "../pages/manager/adhoc/lane/AdhocLaneAdd";
import AdhocLaneView from "../pages/manager/adhoc/lane/AdhocLaneView";
import AdhocLaneEdit from "../pages/manager/adhoc/lane/AdhocLaneEdit";

import AdhocVendorAdd from "../pages/manager/adhoc/vendor/AdhocVendorAdd";
import AdhocVendorView from "../pages/manager/adhoc/vendor/AdhocVendorView";

import AdhocTripView from "../pages/manager/adhoc/trip/AdhocTripView";
import AdhocTripEdit from "../pages/manager/adhoc/trip/AdhocTripEdit";

import CompanyMasterAdd from "../pages/corporate-admin/companymaster/add";
import CompanyMasterList from "../pages/corporate-admin/companymaster/list";
import CompanyMasterEdit from "../pages/corporate-admin/companymaster/edit";
import KiloleterMasterAdd from "../pages/corporate-admin/kiloletermaster/add";
import KiloleterMasterList from "../pages/corporate-admin/kiloletermaster/list";
import KiloleterMasterEdit from "../pages/corporate-admin/kiloletermaster/edit";
import TonnageMasterAdd from "../pages/corporate-admin/tonnagemaster/add";
import TonnageList from "../pages/corporate-admin/tonnagemaster/list";
import TonnageMasterEdit from "../pages/corporate-admin/tonnagemaster/edit";
import VehicleCategoryList from "../pages/corporate-admin/vehiclecategory/list";
import AddVehicleCategory from "../pages/corporate-admin/vehiclecategory/add";
import VehicleCategoryEdit from "../pages/corporate-admin/vehiclecategory/edit";
import CustomerMasterLaneEditForm from "../pages/corporate-admin/customermaster/edit/CustomerMasterLaneEditForm";
import LoadingReport from "../pages/reports/list/loading-report";
import VehicleShortageSummaryReport from "../pages/reports/list/vehicle-shortage-summary-report";
import TripExpensesReport from "../pages/reports/list/trip-expenses-report";
import PerformanceReport from "../pages/reports/list/performance-report";
import MonthlyLoadingReport from "../pages/reports/list/monthly-loading-graph";
import EmiReport from "../pages/reports/list/emi-report";
import FleetAssignment from "../pages/corporate-admin/drivermaster/fleetAssignment";




function AppRoutes() {
   return (
      <Routes>
         {/* Common Routes */}
         <Route path="/Login" element={<Login />} />

         {/* Protected Routes */}
         <Route element={<Skeleton />}>
            {/* Home */}
            <Route index path="/" element={<HomeDashboard />} />
            <Route path="dashboard" element={<HomeDashboard />} />

            {/* Profile */}
            <Route path={RouteNames.profileView} element={<Profile />} />
            {/* User Routes */}
            <Route path={RouteNames.userAddForm} element={<UserAddForm />} />
            <Route path={RouteNames.userList} element={<UserList />} />
            <Route path={RouteNames.userEdit} element={<UserEdit />} />

            {/* Fleet Master Routes */}
            <Route path={RouteNames.fleetMasterAddForm} element={<FleetMasterAddForm />} />
            <Route path={RouteNames.fleetMasterView} element={<FleetMasterView />} />
            <Route path={RouteNames.fleetMasterList} element={<FleetMasterList />} />

            {/* Driver Master Routes */}
            <Route path={RouteNames.driverMasterAddForm} element={<DriverMasterAddForm />}/>
            <Route path={RouteNames.driverMasterView} element={<DriverMasterList />} />
            <Route path={RouteNames.driverMasterEdit} element={<DriverMasterEdit />} />
            <Route path={RouteNames.fleetAssignment} element={<FleetAssignment />} />

            {/* Helper Master Routes */}
            <Route path={RouteNames.helperMasterAddForm} element={<HelperMasterAddForm />} />
            <Route path={RouteNames.helperMasterView} element={<HelperMasterView />} />
            <Route path={RouteNames.helperMasterEdit} element={<HelperMasterEdit />} />

            {/* Customer Master Routes */}
            <Route path={RouteNames.customerMasterAddForm} element={<CustomerMasterAddForm />}/>
            <Route path={RouteNames.customerMasterView} element={<CustomerMasterView />}/>
            <Route path={RouteNames.customerMasterEdit} element={<CustomerMasterEditForm />}/>
            <Route path={RouteNames.customerMasterLaneEdit} element={<CustomerMasterLaneEditForm />}/>

            {/* Vendor Master Routes */}
            <Route path={RouteNames.vendorMasterAddForm} element={<VendorMasterAdd />} />
            <Route path={RouteNames.vendorMasterView} element={<VendorMasterView />} />
            <Route path={RouteNames.vendorMasterEdit} element={<VendorMasterEdit />} />

            {/* Lane Master Routes */}
            <Route path={RouteNames.LaneMasterAddForm} element={<LaneMasterAdd />} />
            <Route path={RouteNames.laneMasterView} element={<LaneMasterView />} />
            <Route path={RouteNames.laneMasterEdit} element={<LaneMasterEdit />} />

            {/* Contractor Master Routes */}
            <Route path={RouteNames.ContractorMasterAddForm} element={<ContractorMasterAdd />}/>
            <Route path={RouteNames.contractorMasterView} element={<ContractorMasterView />}/>
            <Route path={RouteNames.contractorMasterEdit} element={<ContractorMasterEdit />} />

            {/* Location Master Routes */}
            <Route path={RouteNames.LocationMasterAddForm} element={<LocationMasterAdd />}/>
            <Route path={RouteNames.LocationMasterView} element={<LocationMasterView />}/>
            <Route path={RouteNames.LocationMasterEdit} element={<LocationMasterEdit />}/>

            {/* Company Master Routes */}
            <Route path={RouteNames.CompanyMasterAddForm} element={<CompanyMasterAdd />}/>
            <Route path={RouteNames.CompanyMasterView} element={<CompanyMasterList/>} />
            <Route path={RouteNames.CompanyMasterEdit} element={<CompanyMasterEdit />} />

            {/* Kiloleter Master Routes */}
            <Route path={RouteNames.kiloleterMasterAddForm} element={<KiloleterMasterAdd />}/>
            <Route path={RouteNames.kiloleterMasterView} element={<KiloleterMasterList/>}/>
            <Route path={RouteNames.kiloleterMasterEdit} element={<KiloleterMasterEdit/>}/>
            
            {/* Tonnage Master Routes */}
            <Route path={RouteNames.tonnageMasterAddForm} element={<TonnageMasterAdd/>}/>
            <Route path={RouteNames.tonnageMasterView} element={<TonnageList/>}/>
            <Route path={RouteNames.tonnageMasterEdit} element={<TonnageMasterEdit/>} />

            {/* Vehicle Category Routes */}
            <Route path={RouteNames.vehicleCategoryMasterAddForm} element={<AddVehicleCategory/>}/>
            <Route path={RouteNames.vehicleCategoryMasterView} element={<VehicleCategoryList/>}/>
            <Route path={RouteNames.vehicleCategoryMasterEdit} element={<VehicleCategoryEdit/>}/>

            {/* Trip Routes */}
            <Route path={RouteNames.contaractualTripAdd} element={<ContractualTripAdd />}/>
            <Route path={RouteNames.contractualTripView} element={<ContractualTripView />}/>
            <Route path={RouteNames.contractualTripEdit} element={<ContractualTripEdit />}/>

            <Route path={RouteNames.adhocTripView} element={<AdhocTripView />} />
            <Route path={RouteNames.adhocTripEdit} element={<AdhocTripEdit />} />
            {/* <Route path={RouteNames.managerVendorView} element={<ViewTrip />} /> */}

            {/* Manager Adhoc Routes */}
            <Route path={RouteNames.adhocLaneAdd} element={<AdhocLaneAdd />} />
            <Route path={RouteNames.adhocLaneView} element={<AdhocLaneView />} />
            <Route path={RouteNames.adhocLaneEdit} element={<AdhocLaneEdit />} />
            <Route path={RouteNames.adhocVendorAdd} element={<AdhocVendorAdd />} />
            <Route path={RouteNames.adhocVendorView} element={<AdhocVendorView />} />


            {/* Reports */}
            <Route path={RouteNames.loadingReport}  element={<LoadingReport />} />
            <Route path={RouteNames.vehicleShortageSummaryReport}  element={<VehicleShortageSummaryReport />} />
            <Route path={RouteNames.tripExpensesReport}  element={<TripExpensesReport />} />
            <Route path={RouteNames.performanceReport}  element={<PerformanceReport />} />
            <Route path={RouteNames.monthlyLoadingGraph}  element={<MonthlyLoadingReport />} />
            <Route path={RouteNames.emiReport} element={<EmiReport />} />


         </Route>
      </Routes>
   );
}

export default AppRoutes;



